import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

let sparkId = 0;

export const CursorSparkles = () => {
  const [sparks, setSparks] = useState([]);

  useEffect(() => {
    let last = 0;
    const onMove = (e) => {
      if (e.pointerType === "touch") return;
      const now = performance.now();
      if (now - last < 55) return;
      last = now;
      const s = {
        id: sparkId++,
        x: e.clientX,
        y: e.clientY,
        dx: Math.random() * 28 - 14,
        size: 3 + Math.random() * 5,
      };
      setSparks((arr) => [...arr.slice(-16), s]);
      setTimeout(() => setSparks((arr) => arr.filter((x) => x.id !== s.id)), 900);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <div className="fixed inset-0 z-[70] pointer-events-none hidden sm:block" aria-hidden="true">
      <AnimatePresence>
        {sparks.map((s) => (
          <motion.span
            key={s.id}
            initial={{ opacity: 1, scale: 1, x: s.x, y: s.y }}
            animate={{ opacity: 0, scale: 0.15, x: s.x + s.dx, y: s.y - 34 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.85, ease: "easeOut" }}
            className="absolute rounded-full"
            style={{
              width: s.size,
              height: s.size,
              background: "#F3E5AB",
              boxShadow: "0 0 10px rgba(243,229,171,0.9)",
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
